<template>
  <div>
    <!--기본정보-->
    <field-select-module v-model="form.stdInfo" :board="board" :is-print="isPrint" />

    <!-- 작업계획서 -->
    <div class="mt-28px">
      <h5 class="my-4"><i class="dot"></i> 작업계획서</h5>
      <div class="writeGridContainer">
        <div>
          <div>팀명</div>
          <p v-if="isPrint" class="print-input"> {{ form.팀명 }}</p>
          <ml-input v-else :readonly="board.readonly" :isPrint="isPrint" v-model="form.팀명" :max="300" :visible-counter="true" />
        </div>
        <div>
          <div>운영개소</div>
          <p v-if="isPrint" class="print-input"> {{ form.운영개소 }}</p>
          <ml-input v-else :readonly="board.readonly" :isPrint="isPrint" v-model="form.운영개소" :max="100" :visible-counter="true" />
        </div>
        <div>
          <div>구분</div>
          <div class="flex flex-col gap-2">
            <p v-if="isPrint" class="print-input"> {{ form.구분 }}</p>
            <custom-option-selector v-else :readonly="board.readonly" :isPrint="isPrint" :options="result_options" v-model="form.구분" addable-option class="flex-1 w-full" />
          </div>
        </div>
        <div>
          <div>Spec</div>
          <p v-if="isPrint" class="print-input"> {{ form.Spec }}</p>
          <ml-input v-else :readonly="board.readonly" :isPrint="isPrint" v-model="form.Spec" :max="100" :visible-counter="true" />
        </div>
        <div>
          <div>장비번호</div>
          <p v-if="isPrint" class="print-input"> {{ form.장비번호 }}</p>
          <ml-input v-else :readonly="board.readonly" :isPrint="isPrint" v-model="form.장비번호" :max="100" :visible-counter="true" />
        </div>
      </div>

      <div class="writeGridContainer">
        <div>
          <div>작업계획서 첨부</div>
          <p v-if="isPrint" class="print-input">{{ form.작업계획서첨부 ? form.작업계획서첨부.fileName : "" }}</p>
          <FileUploader v-else :readonly="board.readonly" v-model="form.작업계획서첨부" />
        </div>
      </div>
    </div>

    <!-- 파일첨부 -->
    <file-upload-module :readonly="board.readonly" v-model="form.fileList" :is-print="isPrint" class="mt-8" />
  </div>
</template>

<script>
import FieldSelectModule from "@/views/modules/FieldSelectModule";
import FileUploadModule from "@/views/modules/FileUploadModule.vue";
import FileUploader from "@/components/FileUploader.vue";
import CustomOptionSelector from "@/components/selector/CustomOptionSelector";

export default {
  components: {
    FileUploader,
    FileUploadModule,
    FieldSelectModule,
    CustomOptionSelector,
  },
  props: {
    isPrint: Boolean,
    board: Object,
    value: Object,
    header: Object,
  },
  data() {
    return {
      result_options: ["지게차", "로더", "굴착기", "덤프트럭", "기타(직접입력)"],

      form: {
        stdInfo: {},
        fileList: [],

        팀명: "",
        운영개소: "",
        구분: "",
        Spec: "",
        장비번호: "",
        작업계획서첨부: {},
      },
    };
  },
  computed: {},
  watch: {
    value: {
      immediate: true,
      deep: true,
      handler(value) {
        const keys = Object.keys(this.form);
        for (const key of keys) {
          if (value[key]) {
            this.form[key] = value[key];
          }
        }
      },
    },
    form: {
      immediate: true,
      deep: true,
      handler(value) {
        this.$emit("input", value);
      },
    },
  },
  created() {
    const keys = Object.keys(this.form);
    for (const key of keys) {
      if (this.value[key]) {
        this.form[key] = this.value[key];
      }
    }
  },
};
</script>
